import axios from "axios";
import { getUnitApiBaseFour, SUB_URL } from "./BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const ReportService = {
  getItem: async () => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.get(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_item_no}`
      );

      console.log("Get Item Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching item data:", error);
      return [];
    }
  },

  getPObyItem: async (value) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("item_no", value || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_po_by_item}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Get PO By Item Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error getting POs by item:", error);
      return [];
    }
  },

  getColorByPO: async (poValue) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("po_no", poValue || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_color}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Get Color By PO Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error getting colors by PO:", error);
      return [];
    }
  },

  getEolReport: async (startDate, endDate, selectedPoNo, selectedItem, value) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();

      const formValues = {
        from_date: startDate,
        to_date: endDate,
        po_no: selectedPoNo,
        item_no: selectedItem,
        color: value,
      };

      Object.entries(formValues)
        .filter(([, val]) => val !== null && val !== undefined && val !== "")
        .forEach(([key, val]) => formData.append(key, val));

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_eol_report}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("EOL Report Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching EOL report:", error);
      return [];
    }
  },

  displayActiveKanban: async (lineData) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("line_no", lineData || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.display_active_kanban}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Active Kanban Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching active kanban:", error);
      return [];
    }
  },

  get_inward_outward_report: async (startDate, endDate, type, location) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("from_date", startDate || "");
      formData.append("to_date", endDate || "");
      formData.append("type", type || "");
      formData.append("location", location || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_inward_outward_report}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Inward Outward Report Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching inward outward report:", error);
      return [];
    }
  },
};

export default ReportService;